import { driverPayoutFor, formatCurrency } from '../../shared/models';

// Flashing "Order Ready" banner (mirrors DriverOrderReadyBannerView).
// Tap → open the order preview; ✕ → dismiss until a new order arrives.
export default function OrderReadyBanner({ order, onTap, onDismiss }) {
  if (!order) return null;
  const num = String(order.orderNumber || order.id).slice(0, 8);
  return (
    <div className="banner-flash-driver pointer-events-auto w-full rounded-2xl p-3 shadow-lg">
      <div className="flex items-center gap-3">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDismiss();
          }}
          className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-500 text-sm font-bold text-white"
          aria-label="Dismiss"
        >
          ✕
        </button>
        <span className="h-3 w-3 shrink-0 animate-pulse rounded-full bg-white" />
        <button onClick={onTap} className="min-w-0 flex-1 text-left text-white">
          <p className="text-sm font-bold">🚚 Order Ready!</p>
          <p className="truncate text-xs text-white/90">
            Order #{num} • {order.restaurantName || 'Restaurant'}
          </p>
          <p className="text-[11px] text-white/80">
            {formatCurrency(driverPayoutFor(order))} • Ready for pickup
          </p>
        </button>
        <button
          onClick={onTap}
          className="shrink-0 text-xl font-bold text-white/70"
          aria-label="View order"
        >
          ›
        </button>
      </div>
    </div>
  );
}
